import Container from '@ui/container/container';
import OptionalComponent from '@ui/optional-component/optional-component';
import Portal from '@ui/portal/portal';

type WaitingIndicatorOverlayProps = {
  display: boolean;
};

const WaitingIndicatorOverlay = ({ display }: WaitingIndicatorOverlayProps) => {
  return (
    <OptionalComponent display={display}>
      <Portal className="position-absolute top-0 width-100-percent height-100-percent z-100">
        <Container background="rgb(0,0,0,0.5)" className="height-100-percent" loading></Container>
      </Portal>
    </OptionalComponent>
  );
};

export default WaitingIndicatorOverlay;
